<div class="card" id="registruGenealogic" [formGroup]="animalForm">
  <div class="card-header">Registru Genealogic</div>

  <div class="card-body">
    <div class="row column-gap-5">
      <div class="col-auto">
        <div class="row mb-1">
          <div class="col-auto">
            <h5>Registru General</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-auto">
            <div class="form-group mb-2">
              <label>
                Țară origine
              </label>
              <ng-select
                [items]="countries"
                bindLabel="name"
                bindValue="id"
                placeholder="Alege țara de origine"
                formControlName="taraorigineid"
                [ngClass]="{ disabled: disabledFields['taraorigineid'] }"
              >
              </ng-select>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group mb-2">
              <label>
                Țară proveniență
              </label>
              <ng-select
                [items]="countries"
                bindLabel="name"
                bindValue="id"
                placeholder="Alege țara de proveniență"
                formControlName="taraprovenientaid"
                [ngClass]="{ disabled: disabledFields['taraprovenientaid'] }"
              >
              </ng-select>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group mb-2">
              <label>
                Secțiune registru general
              </label>
              <ng-select
                placeholder="Alege registru general"
                formControlName="sectiune_reg_general"
                [clearable]="false"
                [searchable]="false"
                [ngClass]="{ disabled: disabledFields['sectiune_reg_general'] || sectionChanged}"
                (change)="rgGenSectionChanged($event)"
              >
                <ng-option [value]="0">Neîncadrat</ng-option>
                <ng-option [value]="1">A</ng-option>
                <ng-option [value]="2">B</ng-option>
                <ng-option [value]="3">C</ng-option>
                <ng-option [value]="4">D</ng-option>
              </ng-select>
            </div>

            <div
              *ngIf="generalSectionChanged"
              class="form-group mb-2"
            >
              <button
                type="button"
                class="btn btn-info"
                [ngbPopover]="popContent"
                [popoverTitle]="popTitle"
                [autoClose]="false"
                popoverClass="popover-style"
                triggers="manual"
                #popover="ngbPopover"
                (click)="viewAfectedDescendants()"
              >
                Verifică descendenți
              </button>
            </div>
          </div>
        </div>
      </div>


      <div class="col-auto">
        <div class="row justify-content-between mb-1">
          <div class="col-auto">
            <h5>Registru Genealogic Român</h5>
          </div>

          <div class="col-auto d-flex align-items-center">
            <span
              *ngIf="!disabledFields['sectiune_reg_general'] && animalForm.value.id"
              role="button"
              class="btn btn-xs btn-info"
              (click)="viewReasons(animalForm.value.id)"
            >
              Evaluare încadrare
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-auto">
            <div class="form-group mb-2">
              <label>
                Secțiune registru
              </label>
              <ng-select
                formControlName="sectiune_reg_ro"
                [items]="[
                  {'value': 0, 'label': 'Neîncadrat'},
                  {'value': 1, 'label': 'Principală'},
                  {'value': 2, 'label': 'Suplimentară A'},
                  {'value': 3, 'label': 'Suplimentară B'},
                  {'value': 4, 'label': 'Suplimentară C'},
                  {'value': 5, 'label': 'Suplimentară D'},
                ]"
                bindValue="value"
                bindLabel="label"
                [clearable]="false"
                [searchable]="false"
                (change)="rgSectionChanged($event['value'])"
                [ngClass]="{
                  'is-invalid': errorMessage,
                  disabled: disabledFields['sectiune_reg_ro'] || generalSectionChanged
                }"
              >
                <ng-template ng-option-tmp ng-label-tmp let-item="item">
                  <div
                    [ngClass]="{
                      'text-danger': item['value'] === 0,
                    }"
                  >
                    {{ item['label'] }}
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div
              *ngIf="sectionChanged"
              class="form-group mt-3 text-center"
            >
              <button
                type="button"
                class="btn btn-info"
                [ngbPopover]="popContent"
                [popoverTitle]="popTitle"
                [autoClose]="false"
                popoverClass="popover-style"
                triggers="manual"
                #popover="ngbPopover"
                (click)="viewAfectedDescendants()"
              >
                Verifică descendenți
              </button>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group mb-2">
              <label>
                Număr Registru
              </label>
              <div
                *ngIf="animalForm.value.sectiune_reg_ro && animalForm.value.sectiune_reg_ro !== 0"
                class="pt-1"
              >
                {{ animalForm.value.numarmatricol }}
              </div>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group mb-2">
              <label>
                Data intrării în RG
              </label>
              <div class="pt-1">
                {{ animalForm.value.data_rg_dmy }}
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="errorMessage"
          class="row text-danger mb-2"
          [ngClass]="{
            'd-block': errorMessage
          }"
        >
          {{ errorMessage }}
        </div>
      </div>

    </div>

  </div>
</div>

<app-view-reason-modal
  [reasonModalData]="reasonModalData"
>
</app-view-reason-modal>


<ng-template #popTitle>
  <div class="text-center">
    <h4>{{ fitMessage.AfectedChildrens }}</h4>
  </div>
</ng-template>


<ng-template #popContent>
  <div class="popover-content">
    <div [innerHtml]="fitMessage.message" class="text"></div>
  </div>

  <div class="separator mt-1 mb-2"></div>

  <div class="col-sm-12 mb-1">
    <button
      type="button"
      class="btn btn-sm btn-dark"
      ngbTooltip="Revenire la secțiunea anterioară"
      (click)="cancelUpdateDescendants()"
    >
      Anulează
    </button>
    <button
      type="button"
      ngbTooltip="Actualizează animalul și descendenții săi"
      class="btn btn-sm btn-success float-right"
      (click)="updateDescendants()"
    >
      Actualizează
    </button>
  </div>
</ng-template>
